export default 'You are invited by:'
